import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { ExerciseModule, Tile } from '@app/models/content';
import { ToolsService } from '@app/services/tools/tools.service';
import { Breakpoints } from '@app/shared/enums';
import { Subscription } from 'rxjs';
import { EventsService } from '@app/services/events/events.service';

@Component({
  selector: 'app-exercise',
  templateUrl: './exercise.component.html',
  styleUrls: ['./exercise.component.scss']
})
export class ExerciseComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() module: ExerciseModule;

  isMobile = this.toolsService.bpIsLowerOrEqualThan(Breakpoints.small);
  itemsPerPages = 3;
  itemsToDisplay: Tile[] = [];
  itemsTotal: number;
  subscriptions: Subscription[] = [];
  entityToScroll: string;

  @ViewChild('exerciseBottom') exerciseBottom: ElementRef;
  @ViewChildren('exerciseItems') exerciseItems: QueryList<any>;

  constructor(
    private toolsService: ToolsService,
    private eventsService: EventsService
  ) { }

  ngOnInit() {
    if (this.module.exercises) {
      this.module.exercises.forEach(exercise => exercise.openExternal = true);
      this.itemsTotal = this.module.exercises.length;
    }

    if (this.isMobile) {
      this.displayMoreItems();
    } else {
      this.itemsToDisplay = this.module.exercises;
    }

    this.eventsService.on(`exercise--${this.module.slug}:navigate-to`, this.onNavigateTo);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.eventsService.off(`exercise--${this.module.slug}:navigate-to`, this.onNavigateTo);
  }

  ngAfterViewInit(): void {
    this.subscriptions.push(
      this.exerciseItems.changes.subscribe(() => {
        if (this.entityToScroll) {
          this.scrollToExercise(this.entityToScroll);
          this.entityToScroll = null;
        } else {
          this.toolsService.scrollIntoView(this.exerciseBottom.nativeElement, 'end');
        }
      })
    );
  }

  onNavigateTo = (slug: string) => {
    if (this.module.isSlider) {
      if (this.isMobile) {
        const slugIndex = this.module.exercises.findIndex(
          tile => tile.entitySlug === slug
        );
        if (slugIndex) {
          if (slugIndex <= this.itemsPerPages - 1) {
            this.scrollToExercise(slug);
          } else {
            this.entityToScroll = slug;
            this.itemsToDisplay = this.module.exercises.slice(0, slugIndex + 1);
          }
        }
      } else {
        this.eventsService.broadcast(`slider--${this.module.slug}:slide-to`, slug);
      }
    } else  {
      this.scrollToExercise(slug);
    }
  }

  scrollToExercise(entitySlug: string) {
    const tileEl = this.toolsService.document.querySelector(
      `[data-tile-entity-slug="${entitySlug}"]`
    );
    if (tileEl) {
      const calculatedTop =
        window.scrollY +
        tileEl.getBoundingClientRect().top -
        this.toolsService.fileModuleScrollOffset;

      if (calculatedTop > 0) {
        this.toolsService.scrollTo({
          top: calculatedTop
        });
      }
    }
  }

  displayMoreItems() {
    const start = this.itemsToDisplay.length;
    this.itemsToDisplay = this.itemsToDisplay.concat(
      this.module.exercises.slice(
        start, start + this.itemsPerPages
      )
    );
  }

}
